module.exports = __webpack_public_path__ + "fef3374ee75399c3f9506046fe53618e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg22.jpeg
// module id = 31
// module chunks = 0